import AbstractMediator from "../../../core/ui/AbstractMediator";

export default class EmailDraftSentInputComponentMediator extends AbstractMediator {

    constructor(target, dispatcher, languagePack) {
        super(target, dispatcher);

        this._dispatcher = dispatcher;
        this._languagePack = languagePack;
        this._mcBlock = this._target.mcBlock;
    }

    initialize() {
        super.initialize();

        const initialTextFieldBounds = this._target.textField.getBounds();
        const initialLineBounds = this._target.indentLine.nominalBounds;
        const textFieldHeightToLineHeightFactor = initialLineBounds.height / initialTextFieldBounds.height;

        var selectedOption = this._mcBlock.getSelectedOption();
        if (selectedOption != null) {
            this._target.textField.text = selectedOption.getDescription().getText();
        }

        const newTextFieldBounds = this._target.textField.getBounds();
        const targetLineHeight = newTextFieldBounds.height * textFieldHeightToLineHeightFactor;
        this._target.indentLine.scaleY = targetLineHeight / initialLineBounds.height;

        const origSkinBounds = this._target.getBounds();
        this._target.setBounds(origSkinBounds.x, origSkinBounds.y, origSkinBounds.width, this._target.textField.getBounds().height);
    }

    destroy() {
        super.destroy();

        this._mcBlock = null;
    }
}